import request from '@/utils/request'

// 优惠券列表
export function getCouponList(storeCode: string) {
  return request({
    url: '/api/store/manage/notice',
    method: 'get',
    params: {
      storeCode
    }
  })
}

// 保存/编辑优惠券
export function saveCoupon(data: any) {
  return request({
    url: '/api/store/manage/notice',
    method: 'post',
    data
  })
}

// 删除优惠券
export function deleteCoupon(id: string) {
  return request({
    url: `/api/store/manage/notice/${id}`,
    method: 'delete'
  })
}

// 启用禁用优惠券
export function enableCoupon(id: string, enable: boolean) {
  return request({
    url: '/api/store/manage/notice/enable',
    method: 'post',
    data: {
      id,
      enable
    }
  })
}

export function checkWiioPaid() {
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       data: {
  //         NyFeePaid: false,
  //         BackUrl: 'https://prepub-3.wiioreg.com/CustomPersonCenter/Index'
  //       }
  //     })
  //   }, 500) // 0.5秒延迟
  // })

  return request({
    url: `/api/user/checkWiioPaid`,
    method: 'get'
  })
}
